import * as React from "react";
import { Box, Checkbox, FormControlLabel, FormGroup, Grid, InputBase, Paper, } from "@material-ui/core";
export var Search = function (_a) {
    var _b;
    var search = _a.search, genres = _a.genres;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { mt: 2, component: Paper, pl: 2, pr: 2 },
            React.createElement(Box, { p: 1, display: "flex", alignItems: "center", component: "form" },
                React.createElement(InputBase, { value: search.value, onChange: search.onChange, fullWidth: true, placeholder: "\u041F\u043E\u0438\u0441\u043A", autoFocus: true }))),
        React.createElement(Box, { component: Paper, p: 2, mt: 2 },
            React.createElement(Grid, { container: true }, (_b = genres.entries) === null || _b === void 0 ? void 0 : _b.map(function (genre) { return (React.createElement(Grid, { key: genre.id, item: true, xs: 3 },
                React.createElement(FormGroup, null,
                    React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: genre.isChecked, onChange: function () { return genres.toggleById(genre.id); }, name: "published", color: "primary" }), label: genre.title })))); })))));
};
